import React from "react";

import { SaleStatusBadge } from "components/Badge/SaleStatusBadge";
import { EContractStatus } from "constants/eContract";

export const E_CONTRACT_STATUS_COLOR: Record<string, string> = {
  [EContractStatus.NOT_DRAFTED]: "gray78",
  [EContractStatus.PART_DRAFTED]: "inProgress",
  [EContractStatus.DRAFTED]: "gray9C",
  [EContractStatus.PART_SENT]: "inProgress",
  [EContractStatus.SENT]: "inProgress",
  [EContractStatus.PART_ACCEPTED]: "inProgress",
  [EContractStatus.ACCEPTED]: "success",
};

interface EContractStatusBadgeProps {
  value: string;
  forGrid?: boolean;
}

export function EContractStatusBadge({
  value,
  forGrid = false,
}: EContractStatusBadgeProps) {
  return (
    <SaleStatusBadge
      label={value}
      color={E_CONTRACT_STATUS_COLOR[value] ?? "gray9C"}
      forGrid={forGrid}
    />
  );
}

export function EContractStatusRenderer({
  value,
  node,
}: {
  value: string | null;
  node: { group: boolean };
}) {
  if (node?.group) {
    return value ?? null;
  }
  if (!value) return null;
  return <EContractStatusBadge value={value} forGrid />;
}
